let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;

  setTimeout(function () {
    // loadScript("//www.wearcomet.com/cdn/shop/t/155/assets/cart-drawer.js?v=45654657555496281121763104199");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-cart.css?v=61086454150987525971763104199");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-cart-drawer.css?v=89336035772017415521763104197");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-totals.css?v=86168756436424464851763104198");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-discounts.css?v=152760482443307489271763104198");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-loading-overlay.css?v=167310470843593579841763104202");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-cart-items.css?v=29412722223528841861763104198");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-list-social.css?v=52211663153726659061763104201");

    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-accordion.css?v=180964204318874863811763104199");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-rating.css?v=24573085263941240431763104199");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-loading-overlay.css?v=167310470843593579841763104202");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-deferred-media.css?v=8449899997886876191763104201");
    
    loadScript("//www.wearcomet.com/cdn/shop/t/155/assets/details-modal.js?v=4511761896672669691763104198");
    loadScript("//www.wearcomet.com/cdn/shop/t/155/assets/cart-notification.js?v=160453272920806432391763104200");
    loadScript("//www.wearcomet.com/cdn/shop/t/155/assets/search-form.js?v=113639710312857635801763104198");
    loadScript("//www.wearcomet.com/cdn/shop/t/155/assets/cart.js?v=105288208986334364251763104200");
    loadScript("//www.wearcomet.com/cdn/shop/t/155/assets/cart-drawer-script.js?v=24308693613533450291763104198");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/lazy-video-styles.css?v=107481450961078042501763104197");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/custom-mega-menu.css?v=124369009696107595511763104199");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/section-footer.css?v=171161867995400310821763104199");
    // loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/component-menu-drawer.css?v=178538862316763244501763104199");
    loadCSS("//www.wearcomet.com/cdn/shop/t/155/assets/footer.css?v=87833187280690901731763104235");

    loadCSS("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css");
    loadScriptWithCallBack('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js', function(){
        const announceSwiper = new Swiper('.announcement-slider', {
        loop: true,
        speed: 300,
        slidesPerView: 1,
        slidesPerGroup: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: false, // No arrows
        pagination: false, // No dots
      });

      const logossSwiper = new Swiper('.logo-sliders-swiper', {
      loop: false,
      // speed: 300,
      slidesPerView: 3,
      slidesPerGroup: 3,
      navigation: false,
      pagination: false,
      breakpoints: {
        481: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        601: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          loop: true, 
        },
        1025: {
          slidesPerView: 6,
          slidesPerGroup: 3,
          loop: false, // Slick had `infinite: false` on desktop
        }
      }
    });

    document.querySelectorAll('.placeholder-slk-prnt').forEach(el => {
      el.style.opacity = '0';
    });

    document.querySelectorAll('.onrendered-slider-prnt').forEach(el => {
      el.style.opacity = '1';
    });

    loadScript("//www.wearcomet.com/cdn/shop/t/155/assets/quick-add-to-cart.js?v=97566593955325822821763106625");

    // const swiperContainer = document.querySelector('.image-with-text-product-swiper');
    // const productFeatureSwiper = new Swiper('.image-with-text-product-swiper', {
    //     slidesPerView: 1.1,
    //     spaceBetween: 30,
    //     loop: false,
        
    //     // Navigation arrows
    //     navigation: {
    //       nextEl: '.swiper-button-next',
    //       prevEl: '.swiper-button-prev',
    //     },
        
    //     // Pagination
    //     pagination: {
    //       el: '.swiper-pagination',
    //       clickable: true,
    //     },
        
    //     // Responsive breakpoints
    //     breakpoints: {
    //       1001: {
    //         // Disable swiper functionality on desktop
    //         // enabled: false,
    //         // slidesPerView: 'auto',
    //         slidesPerView: 2,
    //         spaceBetween: 20,
    //         centeredSlides: true,
    //         loop: true,
    //       }
    //     },
        
    //     // Enable touch/swipe on mobile
    //     touchRatio: 1,
    //     touchAngle: 45,
    //     grabCursor: true,
        
    //     // Autoplay (optional - remove if not needed)
    //     // autoplay: {
    //     //   delay: 5000,
    //     //   disableOnInteraction: false,
    //     // },
    //   });


    const totalSlides = document.querySelectorAll('[id^="shopify-section-"] .hide-mobile .image-with-text-product-swiper .swiper-slide').length;
    const shoe_tech_all = document.querySelectorAll('[id^="shopify-section-"] .image-with-text-product-swiper');
    console.log({totalSlides})
    shoe_tech_all.forEach((showTechSlider) => {
        const productFeatureSwiper = new Swiper(showTechSlider, {
          slidesPerView: 1.1,
          spaceBetween: 30,
          loop: false,
          
          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          
          // Pagination
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          
          // Responsive breakpoints
          breakpoints: {
            1001: {
              // Disable swiper functionality on desktop
              // enabled: false,
              // slidesPerView: 'auto',
              slidesPerView: 2,
              spaceBetween: 20,
              centeredSlides: totalSlides > 3,
              loop: true
            }
          },
          
          // Enable touch/swipe on mobile
          touchRatio: 1,
          touchAngle: 45,
          grabCursor: true,
          
          // Autoplay (optional - remove if not needed)
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
        });
    })

    })
  }, 10);

  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts();
} else {
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}